






import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class StubCmp extends Vue {
  @Prop({default: "Раздел находится в разработке, скоро здесь будут отображаться актуальные данные"}) public readonly title!: string;
}
